<script setup lang="ts">
import type { EquipmentTypeCatalogDto } from '@/api/generator';
import { routenames } from '@/router/routenames.ts';
import { VImg } from 'vuetify/components';
import Button from '@/components/buttons/Button.vue';

type QaEquipmentAddQuickLinksProps = {
  options?: EquipmentTypeCatalogDto[];
};

defineProps<QaEquipmentAddQuickLinksProps>();
const quickLinkButtonHeight = 52;

function getImageUrl(name: string) {
  return new URL(`/src/assets/images/qaEquipment/${name}.svg`, import.meta.url).href;
}
</script>
<template>
  <div v-if="options?.length">
    <template v-for="item in options" :key="item.id">
      <Button
        class="mr-4"
        variant="primary"
        size="x-large"
        :label="`${item.model}${item.subModel ? ' | ' + item.subModel : ''}`"
        :to="{
          name: routenames.qaEquipment.add.fromCatalog,
          params: { template: item.id },
        }"
      >
        <template #prepend>
          <v-avatar
            rounded="0"
            :size="quickLinkButtonHeight"
            :style="{ backgroundColor: 'transparent' }"
          >
            <v-img v-if="item.typeNumber" :src="getImageUrl(item.typeNumber)" />
          </v-avatar>
        </template>
      </Button>
    </template>
  </div>
</template>
